import i18next from 'i18next';
import * as Yup from 'yup';

const baseSchema = Yup.object().shape({
  marca: Yup.string().required(i18next.t('required_field')),
  modello: Yup.string().required(i18next.t('required_field')),
  allestimento: Yup.string().required(i18next.t('required_field')),
  durata: Yup.number()
    .required(i18next.t('required_field'))
    .test((val) => val >= 0),
  kmAnnui: Yup.number()
    .required(i18next.t('required_field'))
    .test((val) => val >= 0),
  incendioFurtoScopertoPerc: Yup.number()
    .required(i18next.t('required_field'))
    .test((val) => val >= 0),
  kaskoFranchigia: Yup.number()
    .required(i18next.t('required_field'))
    .test((val) => val >= 0),
  rcaPenaleRisarcitoria: Yup.number()
    .required(i18next.t('required_field'))
    .test((val) => val >= 0),
  gommeIllimitateYN: Yup.boolean(),
  anticipoNoIva: Yup.number()
    .required(i18next.t('required_field'))
    .test((val) => val >= 0),
  // gommeYN: Yup.boolean(),
  tipoCliente: Yup.string().required(i18next.t('required_field')),
  nome: Yup.string().when('tipoCliente', {
    is: (value: string) => ['privato', 'libero_professionista'].includes(value),
    then: (schema) => schema.required(i18next.t('required_field')),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  cognome: Yup.string().when('tipoCliente', {
    is: (value: string) => ['privato', 'libero_professionista'].includes(value),
    then: (schema) => schema.required(i18next.t('required_field')),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  ragioneSociale: Yup.string().when('tipoCliente', {
    is: (value: string) => ['azienda'].includes(value),
    then: (schema) => schema.required(i18next.t('required_field')),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  tipoGomma: Yup.string().when('gommeYN', {
    is: true,
    then: (schema) => Yup.string().required(i18next.t('required_field')),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  autoSostitutivaGruppo: Yup.string().when('autoSostitutivaYN', {
    is: true,
    then: (schema) => Yup.string().required(i18next.t('required_field')),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
  numTrenoGommeEstive: Yup.string().when(['gommeYN', 'gommeIllimitateYN'], {
    is: (gommeYN, gommeIllimitateYN) => !gommeYN || gommeIllimitateYN,
    then: (schema) => schema.notRequired().nullable(),
    otherwise: () => Yup.string().required(i18next.t('required_field')),
  }),
  numTrenoGommeInvernali: Yup.string().when(['gommeYN', 'gommeIllimitateYN'], {
    is: (gommeYN, gommeIllimitateYN) => !gommeYN || gommeIllimitateYN,
    then: (schema) => schema.notRequired().nullable(),
    otherwise: () => Yup.number().required(i18next.t('required_field')),
  }),
  optionals: Yup.array().of(
    Yup.object().shape({
      descrizione: Yup.string(),
      valore: Yup.string().nullable(),
    })
  ),
});

export const createRequestSchema = baseSchema.concat(Yup.object().shape({}));

export const updateRequestSchema = baseSchema.concat(Yup.object().shape({
  canone: Yup.number()
    .required(i18next.t('required_field'))
    .test((val) => val >= 0),
  optionals: Yup.array().of(
    Yup.object().shape({
      descrizione: Yup.string(),
      valore: Yup.number()
        .when('unquotable', {
          is: true,
          then: schema => schema.nullable(),
          otherwise: schema => schema
            .required(i18next.t('required_field'))
            .test((val) => val >= 0),

        }),
      unquotable: Yup.boolean().nullable(),
    })
  ),
  noleggiatore: Yup.string().required(i18next.t('required_field')),
}));
